const Success = (props) => {
    const { back, isTranslated } = props;
    return ( 
        <div className="success-page">
            {/* <div>
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <img src={require('../components/images/powercred_logo.jpg')} alt="powercred_logo" height="40" />
                     </div>
                </nav>
            </div> */}
            <h3 className='title-p'>
                {
                    isTranslated ? 'Selamat !' : 'Congratulations !'
                }
            </h3>
            <div className='info-s'>
                {
                     isTranslated ? 'Terima kasih telah berhasil mengirimkan detail Anda. Tim yang bersangkutan akan melalui aplikasi dan kembali !' : 'Thank you for submitting your details successfully. The concernerd team will go through the application and get back !'
                }   
            </div>
            <div className='image-s1'>
                <img src={require(`../components/images/images/namaste.png`)} alt={`logo`} className='namste-image'/>
            </div>
            <h4 className='info-s1'>
                {
                    isTranslated ? 'Terima kasih' : 'Thank You !!'
                }
            </h4>

            {/* <div className='btn-div-p'>
                <button type="button" className='btn nav-btn-pwc back-btn-p' onClick={back}>
                    Back
                </button>
            </div> */}
        </div>
     );
}
 
export default Success;